import React from 'react';

export default function Youtube(props) {
  let ratio = (props.height / props.width) * 100;

  const styles = {
    iframe: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    container: {
      display: 'block',
      position: 'relative',
      paddingBottom: `${ratio}%`,
      paddingTop: `${ratio}px`,
      height: 0,
      borderTop: '5px solid white',
      borderBottom: '5px solid white'
    }
  }

  return <div style={styles.container}><iframe title={props.title} src={props.video} style={styles.iframe} frameBorder="0" allowFullScreen></iframe></div>
}



// WEBPACK FOOTER //
// ./src/components/Assets/Youtube.js